export default "__VITE_ASSET__e4e717f4__"